module.exports = __webpack_public_path__ + "img/dark parchment background.59bae390.jpg";